module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/equipment02-d13ffc16b3cf588a2befeccb9400c3f5.png";